import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }
    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        API Access
                                    </h2>
                                    <p>
                                        All operations on Audiencerate Dashboard are available as REST API, enabling custom app development that fit your needs.
                                        <br />
                                        <br />
                                        Audiencerate will provide you with a <b>personal account</b> for accessing the dashboard UI and your own{' '}
                                        <b>API key credentials</b> so that you can start building the integration with the API.
                                        <br />
                                        <br />
                                        <div className="alert alert-warning">
                                            All APIs are Authenticated using <b>OAuth2</b> standard, so before making a rest call you will need a token to
                                            access the system.
                                        </div>
                                        To get the <b>API key credentials</b>: The Audiencerate APIs use AWS Cognito to handle security and authentication, so
                                        before making a REST call you need to ask the AWS Cognito service for a temporary access token. It's really easy to do
                                        using the SDKs or aws cli, and you can see some example in the <a href="/servertoserver">S2S Section</a> of the
                                        Dashboard under "Code Snippets".
                                        <br />
                                        <br />
                                        After you got the token you will need to pass it to all the APIs calls using the{' '}
                                        <b>
                                            custom HTTP Header <u>Authentication</u>
                                        </b>
                                        .
                                        <br />
                                        <br />
                                        Please refer to our examples under <a href="/servertoserver">S2S Section</a> in the Audiencerate Dashboard to see how it
                                        works in Java or via Command line using aws cli tools. If you need to, you can integrate also with other languages.
                                        please see here: <a href="https://aws.amazon.com/tools/">AWS SDK Library</a>.
                                        <br />
                                        <br />
                                        There is <a href="https://github.com/audiencerate/dashboard-api-sdk">Dashboard SDK</a> project on github to show
                                        examples to use the Audiencerate API.
                                        <br />
                                        <br />
                                        For the full API Documentation go <a href="https://apidocs.audiencerate.com/">Here</a>.
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
